<template>
  <tender-form-label :key="index" 
    :label="options.Name"
    :prop="options.Key"
    :rules="rules"
  >
    <span class="span-areacode" :style="`min-width:${attrs.minWidth}`" @click="showDlgArea">{{form[options.Key]}}</span>
    <area-code ref="AreaCode" :disabled-root="!!param.disabledRoot"></area-code>
  </tender-form-label>
</template>
<script>
import _ from "lodash";
import { mapActions } from 'vuex'
import { mixForFormItem } from '../../../js/mixins'
import AreaCode from '~@/area-code/src'
import utils from '../../../js/utils'
import tenderHook from "../../../js/hooks";
export default {
  name: 'FormInputAreacode',
  mixins: [mixForFormItem],
  components: {AreaCode},
  data() {
    return {
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options = {}} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        this.setFormItemValue(options.Value || '')
      }).catch(() => null)
    },
    inputChangeHandle() {
      this.doSelectEvent()
      this.doValidate()
    },
    showDlgArea() {
      let {form = {}, options = {}} = this
      this.$refs.AreaCode.init({
        type: 'show',
        obj: {
          value: form[options.Key],
          close: value => {
            form[options.Key] = value
            this.inputChangeHandle()
          }          
        }
      }) 
    },
    doSelectEvent(isOnlySet) {
      let { form = {}, options = {}, properties } = this;
      let { Key, Refs = [] } = options;
      let { trueValue } = this.param;
      Refs.forEach((eRef) => {
        let [type, ...args] = eRef;
        switch (type) {
          case "setFormItemRequired":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, value] = args;
              tenderHook.setFormItemRequired(properties, chapterIndex, sectionIndex, keys, form[Key] === value);
            });
            break;
          case "setFormItemDisabled":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, value] = args;
              tenderHook.setFormItemDisabled(properties, chapterIndex, sectionIndex, keys, form[Key] === value);
            });
            break;
          case "setFormItemValue":
            if (!isOnlySet) {
              utils.anoyFunction(() => {
                let [keys, value, same] = args;
                if (same) {
                  tenderHook.setFormItemValue(form, keys, form[Key]);
                  if (trueValue) {
                    tenderHook.setFormItemValue(form, keys, form[`select_${Key}`]);
                  }
                } else {
                  tenderHook.setFormItemValue(form, keys, value);
                }
              });
            }
            break;
          case "setFormItemVisible":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, values] = args;
              let value = trueValue ? form[`select_${Key}`] : form[Key];
              // 接下来写设置可见操作
              tenderHook.setFormItemVisible(properties, chapterIndex, sectionIndex, keys, values.indexOf(value) >= 0);
            });
            break;
          case "setFormItemWithCustom":
            if (!isOnlySet) {
              utils.anoyFunction(() => {
                let [type, ...x] = args;
                console.log(form[Key], Key, this.form, 333);
                tenderHook.setFormItemWithCustom(this, type, options, ...x);
              });
              // tenderHook.refEvent(isOnlySet, this);
            }
            break;
          case "trafficHooks":
          case "houseHooks":
            tenderHook.refEvent(isOnlySet, this)
            // if(!isOnlySet) {
            // }
            break;
        }
      });
      this.doValidate();
    },
  }
}
</script>
<style lang="scss" scoped>
$valueColor: #2393e4;
.span-areacode {
  display: inline-block;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  line-height: 1;
  text-align: left;
  vertical-align: bottom;
  text-indent: 0;
  word-break: break-all;
  outline: none;
  color: $valueColor;
  border-bottom: 1px solid black;
  cursor: pointer;
  &:before {
    content: '';
    display: inline-block;
  }
}
</style>
<style lang="scss">
.is-error {
  .span-areacode {
    border-bottom-color: red;
  }
}
</style>